import store from 'store';
import $ from 'jquery';

import { nextMissionStep, saveCompletedMission } from 'store/actions/help';

const helpDispatch = (type) => {
  //console.log("test dispatch", type);
  //const addInvoice = $( "#test-id1" );
  // if (type === "add-invoice") {
  //   console.log("test:");
  //   //$("#test-id1").get(0).scrollIntoView();
  //   //document.getElementById('elementID').scrollIntoView()
  // }
  //console.log("state:", store.getState());

  store.dispatch(nextMissionStep());
  const { help } = store.getState();
  const currentMission = help.currentMission;
  const currentStep = currentMission.steps[currentMission.currentStep];
  // console.log("HELP:", help);
  // console.log("currentMission:", currentMission);
  if (currentStep && currentStep.success) {
    saveCompletedMission(currentMission.id);
    //console.log("SUCCESS:", currentMission.id);
  }
}

export default helpDispatch;



// WEBPACK FOOTER //
// ./src/components/admin/Help/helpDispatch.js